export const UPGRADE_PRO = 'upgrade-pro'
export const UPGRADE_BUSINESS = 'upgrade-business'
export const UPGRADE_ENTERPRISE = 'upgrade-enterprise'




export enum License {
    FREE                    = 0,                // original old free 25
    FREE_25                 = 4,             // temp free 25 May 19
    FREE_15                 = 3,             // trial has expired - free now - 15 users

    TRIAL_PRO               = 10,         // manual trial - old may 2019
    TRIAL_PRO_14            = 11,       // Pro trial for 14 days
    TRIAL_PRO_21            = 12,       // Pro trial for 21 days
    TRIAL_PRO_30            = 13,       // Pro trial for 30 days
    // TRIAL_BUSINESS_14       = 14,

    PROFESSIONAL_OLD        = 1,    // manual subscription or no subsription
    PROFESSIONAL            = 2,       // automatic subscriptions

    PRO_PAY_PER_USER        = 20,    // automatic payment pay per user
    PRO_FLAT_RATE_10_USERS  = 30,   // automatic payment flat rate 10 users (29.95)
    PRO_FLAT_RATE_15_USERS  = 31,    // automatic payment flat rate 15 users (29.95)


    // New 2023 licenses
    PRO_2023                = 40,
    BUSINESS_2023           = 50,


    ENTERPRISE              = 100        // just to reserve
}